import axios from 'axios';

// axios.defaults.baseURL = 'https://localhost:5001';
axios.defaults.baseURL = 'https://transys.kavosh.app/api';

if (process.env.NODE_ENV !== "development") {
    axios.defaults.baseURL = 'https://transys.kavosh.app/api';
}
